// API Base URL
import { API_BASE_URL } from '../config';

export const baseUrl = API_BASE_URL;
// API Version
export const API_VERSION = 'v1';

// Endpoints
export const PLACE_USAGES_URL = `${baseUrl}placeUsages`;

export const OTHER_FILTEROPTIONS_URL = `${baseUrl}places/filter`;

